"use client";

import { DataGrid } from "../../../../components";
import { Box, Divider, Input, Typography } from "@mui/joy";

import { reportListColumnDef } from "./grid-col-def";
import { Button } from "../../../../shared";
import { FilePlus, Search } from "lucide-react";

const reportExamples = [
    {
        Name: "Lead Source Analysis",
        Description: "Overview of lead sources and their performance",
        Id: "LEAD_SOURCE_ANALYSIS",
    },
    {
        Name: "Month-to-Date Sales Report",
        Description: "Current sales performance for the month",
        Id: "SALES_REPORT",
    },
    {
        Name: "Open Opportunities Overview",
        Description: "List of active sales opportunities",
        Id: "OPEN_OPPORTUNITIES",
    },
    {
        Name: "Project Status Summary",
        Description: "Progress and status update on ongoing projects",
        Id: "PROJECT_STATUS",
    },
];

export default function ListReport() {
    return (
        <Box flex={1} display={"flex"} flexDirection={"column"}>
            <Box mx={3} mt={3} mb={3} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                <Box display={"flex"} alignItems={"center"} gap={3}>
                    <Box>
                        <Typography level="title-lg">Reports</Typography>
                        <Typography level="body-xs">4 Items</Typography>
                    </Box>
                    <Input
                        startDecorator={<Search size={16} />}
                        placeholder="Search reports"
                        size={"sm"}
                        variant="soft"
                        sx={{ border: "1px solid", borderColor: "divider" }}
                    />
                </Box>
                <Box mx={3} display={"flex"} gap={2}>
                    <Button
                        color={"neutral"}
                        size={"sm"}
                        startDecorator={<FilePlus size={16} />}
                        variant={"soft"}
                        sx={{ border: "1px solid", borderColor: "divider" }}
                    >
                        Generate New Report
                    </Button>
                </Box>
            </Box>
            <Divider />
            <Box display={"flex"} flex={1}>
                <DataGrid gridData={reportExamples} columnDefs={reportListColumnDef} animateRows={true} />
            </Box>
        </Box>
    );
}
